import { Box } from 'components/Box';
import { Divider } from 'components/Divider';
import { CmsApiBlock } from 'modules/cms/api/types/CmsApiBlock';
import { getNextRealBlock, getPrevRealBlock } from 'modules/cms/helpers';
import { canHaveHeadingDivider } from 'modules/cms/helpers/canHaveHeadingDivider';
import { getHideFirstHeadingDivider } from 'modules/cms/helpers/getHideFirstHeadingDivider';
import { mustHaveDivider } from 'modules/cms/helpers/mustHaveDivider';
import { mustNotHaveDivider } from 'modules/cms/helpers/mustNotHaveDivider';
import { MappedContentBlock } from 'modules/cms/mappers/MappedContentBlock';

import { CmsBlockContainer } from './CmsBlockContainer';

type Props = {
  mappedBlocks: MappedContentBlock<CmsApiBlock>[];
  withSidebar: boolean;
  fullWidthLayout: boolean;
};

export function CmsBlocksWithContainer({
  mappedBlocks,
  withSidebar,
  fullWidthLayout,
}: Props) {
  return (
    <>
      {mappedBlocks.map((block, index) => {
        const prevBlock = getPrevRealBlock(mappedBlocks, index);
        const nextBlock = getNextRealBlock(mappedBlocks, index);
        const hideFirstHeadingDivider = getHideFirstHeadingDivider({
          index,
          block,
          prevBlock,
        });

        if (block.type === 'ANCHOR') {
          return null;
        }

        return (
          <CmsBlockContainer
            mappedBlock={block}
            mappedBlocks={mappedBlocks}
            index={index}
            id={`cms-block-${block.id}`}
            key={block.id}
            fullWidthLayout={fullWidthLayout}
            withSidebar={withSidebar}
            showHeadingDivider={fullWidthLayout && canHaveHeadingDivider(block)}
            hideFirstHeadingDivider={hideFirstHeadingDivider}
          >
            {fullWidthLayout &&
              index > 0 &&
              mustHaveDivider(block) &&
              prevBlock &&
              !mustNotHaveDivider(prevBlock) &&
              !block.hasBackground && (
                <Box
                  maxWidth={1200}
                  mb={
                    fullWidthLayout
                      ? [64, null, null, 70]
                      : [40, null, null, 60]
                  }
                  mx="auto"
                >
                  <Divider light my={0} />
                </Box>
              )}
            {block.component}
            {fullWidthLayout &&
              index <= mappedBlocks.length - 2 &&
              mustHaveDivider(block) &&
              nextBlock &&
              !mustHaveDivider(nextBlock) &&
              !mustNotHaveDivider(nextBlock) &&
              ((!block.hasBackground && !nextBlock.hasBackground) ||
                (block.hasBackground && nextBlock.hasBackground)) && (
                <Box
                  maxWidth={1200}
                  mt={
                    fullWidthLayout
                      ? [64, null, null, 70]
                      : [40, null, null, 60]
                  }
                  mx="auto"
                >
                  <Divider light my={0} />
                </Box>
              )}
          </CmsBlockContainer>
        );
      })}
    </>
  );
}
